<template>
  <div class="font_icon_store">
    <div class="tabPart">
      <ul class="tablist clearfix">
        <li class="tabLine" v-for="item in typeList"
        :key="item.type"
        :class="{selected:item.type === seTypeId}"
        @click='changeType(item)'>
          <p>{{ item.type_name }}</p>
        </li>
      </ul>
    </div>
     <div class="imgPart" v-loading='isloading' v-if="list.length !== 0">
        <div class="imgContent">
          <ul class="clearfix left_content">
            <li class="imgLine" v-for="(item,index) in list" :key="index" @click="selectImg(item)">
              <div class="imgBox" :class="{selected:~selectImgList.indexOf(item.id)}">
                <img :src="`${item.filePath}`" />
                <span class="activeIcon el-icon-check"></span>
              </div>
            </li>
          </ul>
          <div class="right_content" v-if="selectImgList.length > 0 && selectImgObj.svgPath">
            <div class="preview">
              <p class="title">{{$t('components_draw_icon_index_2192')}}</p>
              <div class="preview_img">
                <embed
              id="embed"
              :src="`/static/image/icon_list/${seTypeId}/${selectImgObj.svgPath}`"
              type="image/svg+xml" width="150" height="150">
              </div>
            <my_radio
              titleWidth="0"
              :selectValue.sync="radio_val"
              hiddenIsShow="false"
              title="">
                <div slot="pull_down_control">
                  <p class="setOne">
                    <my_color :color.sync="seColor" title="" titleWidth="0" @change="color_change"></my_color>
                  </p>
                </div>
              </my_radio>
            </div>
          </div>
        </div>
      </div>
      <div class="noDataTip" v-if="list.length === 0">
        <p>{{$t('components_my_img_selecter_font_icon_store_2318')}}</p>
      </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import {icon_config_new} from '@/base/icon_config_new'
export default {
  data() {
    return {
      seColor: 'rgb(51,51,51,1)',
      radio_val: 'default',
      list: icon_config_new().list[0].children,
      seTypeId: 1,
      isloading:false,
      checkList: this.firstModel,
      selectImgList:[],
      typeList: icon_config_new().list
    };
  },
  computed: {
  },
  methods: {
  createImgFile(){
      const svg_dom = $(document.getElementById('embed').getSVGDocument()).find('svg')[0]
      var svgString = new XMLSerializer().serializeToString(svg_dom);
      var svg = new Blob([svgString], {type: "image/svg+xml;charset=utf-8"});
      var img = new Image();
      var DOMURL = self.URL || self.webkitURL || self;
      var url = DOMURL.createObjectURL(svg);
      const that = this;
      img.src = url;
      img.onload = function () {
        var canvas = document.createElement('canvas')
        canvas.width = 300
        canvas.height = 300
        canvas.getContext('2d').drawImage(img, 0, 0, 300, 300)
        canvas.toBlob(blob => {
          const f = new File([blob], `${Date.now()}img.png`, {type: 'image/png', lastModified: Date.now()})
          for(let i= 0; i < that.checkList.length; i ++) {
            if(that.checkList[i].id == that.selectImgObj.id) {
              that.checkList[i].file = f
            }
          }
        })
      };
    },
    changeType(item){
      this.seTypeId = item.type
      this.list = item.children
      this.checkList = []
      this.selectImgList = []
      this.seColor = 'rgb(51,51,51,1)'
      this.radio_val = 'default'
    },
    selectImg(item){
      this.selectImgObj = item
      this.seColor = 'rgb(51,51,51,1)'
      this.radio_val = 'default'
      if (!~this.selectImgList.indexOf(item.id)) {
        if (this.selectImgList.length === this.limitnum && this.limitnum !== 1) {
          this.$message({
            message: i18n.t('components_my_img_selecter_font_icon_store_new_2322', [this.limitnum]),
            type: 'warning',
            showClose: true
          });
          return false;
        }
        if(this.limitnum === 1){
          this.selectImgList = []
          this.checkList = []
        }
        this.selectImgList.push(item.id)
        this.checkList.push(item)
      } else {
        this.selectImgList.splice(this.selectImgList.indexOf(item.id),1)
        this.checkList = this.checkList.filter(e=>{
          if(e.id !== item.id){
            return e
          }
        })
      }
    },
    //颜色处理，去空格去a
    color_filter(color){
      return color.replace(',1)',')').replace(', 1)',')').replace(/ /g,'').replace('rgba','rgb');
    },
    color_change(e){
      const now_select = this.color_filter(e);//当前选中的颜色
      //遍历svg找相同的颜色
      var path = $(document.getElementById('embed').getSVGDocument()).find('path');
      var polygon = $(document.getElementById('embed').getSVGDocument()).find('polygon');
      var circle = $(document.getElementById('embed').getSVGDocument()).find('circle');
      var ellipse = $(document.getElementById('embed').getSVGDocument()).find('ellipse');
      var line = $(document.getElementById('embed').getSVGDocument()).find('line');
      var rect = $(document.getElementById('embed').getSVGDocument()).find('rect');
      var polyline = $(document.getElementById('embed').getSVGDocument()).find('polyline');
      var list = []
      list = list.concat(path,polygon,circle,ellipse,line,rect,polyline)
      for(var i = 0; i < list.length; i++){
        if(list[i].length > 0) {
          for(let j= 0; j < list[i].length; j++) {
              if($(list[i][j]).css('stroke') == undefined || $(list[i][j]).css('stroke') == 'none' && $(list[i][j]).css('fill') !== 'none') {
                $(list[i][j]).css('fill',now_select);
                $(list[i][j]).css('stroke','none');
              } else {
                $(list[i][j]).css('stroke',now_select);
                $(list[i][j]).css('fill','none');
              }
          }
        } else {
          if($(list[i]).css('stroke') == undefined || $(list[i]).css('stroke') == 'none' && $(list[i]).css('fill') !== 'none') {
            $(list[i]).css('fill',now_select);
            $(list[i]).css('stroke','none');
          } else {
            $(list[i]).css('stroke',now_select);
            $(list[i]).css('fill','none');
          }
        }
      }
      this.createImgFile()
    }
  },
  props: {
    firstModel: {
      // 第一个字段的值（v-model)
      type: Array,
      default: null
    },
    //最大数量
    limitnum: {
      type: Number,
      default: 1
    },
  },
  watch: {
    checkList(val, oldVal) {
      // 数据双向绑定
      this.$emit('update:firstModel', val);
    },
    firstModel(val) {
      // 数据双向绑定
      this.checkList = val;
    },
    radio_val(val) {
      if(val == 'default') {
        for(let i= 0; i < this.checkList.length; i ++) {
          if(this.checkList[i].id == this.selectImgObj.id) {
            this.checkList[i].file = null
            break
          }
        }
        this.seColor = 'rgb(51,51,51,1)'
        this.$nextTick(() => {
          this.color_change(this.seColor)
        })
      }
    }
  },
  mounted() {
    this.isloading = true
    this.$nextTick(() => {
        this.isloading = false
    })
  }
};
</script>

<style lang="scss" scoped>
.iconfont {
  font-size: 25px !important;
}
  .page{
    margin-top: 10px;
    text-align: center;
  }
.font_icon_store {
  font-size: 12px;
  padding: 10px 0px 10px 20px;
  .tabPart {
    .tablist {
      overflow: hidden;
      margin: 10px -10px 10px 0;
      .icon_btn {
        font-size: 15px;
        vertical-align: middle;
        padding-top: 5px;
        cursor: pointer;
        float: right;
      }
    }
  }
  .tabLine {
    margin: 0 18px 10px 0;
    height: 23px;
    line-height: 23px;
    cursor: pointer;
    border: 1px solid #fff;
    text-decoration: none;
    float: left;
    color: #333;
    font-size: 14px;
  }
  .tabLine.selected{
    color: #557ce1
  }
  .noDataTip{
    height: 420px;
    line-height: 420px;
    text-align: center;
    font-size: 30px;
  }
 .imgPart {
    .imgContent {
      width: 100%;
      display: flex;
      flex-direction: row;
      .left_content {
        flex-grow: 1;
        height: 380px;
        overflow: hidden;
        overflow-y: auto;
      }
      .right_content {
        .preview {
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 380px;
          width: 210px;
          background-color: #f3f3f3;
          overflow: hidden;
          img {
            width: 115px;
            height:115px;
          }
          .title {
            margin-top: 26px;
            font-size: 16px;
            color: #000;
            overflow: hidden;
          }
          .preview_img {
            width: 200px;
            height: 200px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
    .imgLine{
      float: left;
      margin-right:24px;
      margin-top: 27px;
      list-style: none;
    }
    .imgBox {
      position: relative;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 95px;
      height: 95px;
      background: #f3f3f3;
      img {
        min-width: 1px;
        min-height: 1px;
        width: 80px;
        height: 80px;;
      }
      .activeIcon {
        display: none;
        width: 18px;
        height: 16px;
        color: #fff;
        position: absolute;
        bottom: 0;
        right: 0;
        background-color: #5874d8;
        line-height: 22px;
        font-size: 12px;
        padding: 0 3px;
        border-top-left-radius: 100%;
      }
    }
    .imgBox.selected{
      border: 1px solid #5874d8;
      .activeIcon {
        display: block;
      }
    }
    .imgBox:hover{
      border: 1px solid #5874d8;
    }
  }
}
.showPart {
  padding: 30px 30px 20px 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/my_img_selecter/font_icon_store_new.vue